import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useUSAJILI } from '@hooks/useUSAJILI';
import { USAJILI_COUNTIES } from '@types';
import { USAJILIDateRangePicker } from './USAJILIDateRangePicker';

/**
 * Global filter bar — (1) County, (2) Date range.
 * Sits in the header's tab row and applies to every page:
 * Dashboard, Pivot table and Daily data.
 */
export const USAJILIFilterBar: React.FC = () => {
  const { filters, updateFilter, resetFilters, metadata } = useUSAJILI();
  const counties = metadata?.counties?.length ? metadata.counties : USAJILI_COUNTIES;

  const anyActive = filters.county !== 'All' || !!filters.date_from || !!filters.date_to;

  const fieldSx = { '& .MuiInputBase-root': { height: 34, fontSize: '0.8rem' } };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <FormControl size="small" sx={{ width: { xs: 'auto', sm: 180 }, flex: { xs: 1, sm: 'none' }, minWidth: 140, ...fieldSx }}>
        <InputLabel id="usajili-county-lbl">County</InputLabel>
        <Select
          labelId="usajili-county-lbl"
          label="County"
          value={filters.county}
          onChange={(e) => updateFilter('county', e.target.value)}
        >
          <MenuItem value="All">All Counties</MenuItem>
          {counties.map((c) => (
            <MenuItem key={c} value={c}>{c}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <USAJILIDateRangePicker />

      <Tooltip title="Clear filters">
        <span>
          <IconButton
            onClick={() => resetFilters()}
            size="small"
            disabled={!anyActive}
            sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
